import { render, staticRenderFns } from "./Authors.vue?vue&type=template&id=8b88590a&lang=pug&"
import script from "./Authors.vue?vue&type=script&lang=js&"
export * from "./Authors.vue?vue&type=script&lang=js&"
import style0 from "./Authors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports